<template>
  <p
    class="mb-0 flex justify-between items-center font-medium rounded-full text-xs w-fit"
    :class="['md_row-start-1', stock.change >= 0 ? 'bg-copper-50' : 'bg-red-50']"
    data-testid="stock-price-change"
  >
    <ArrowLongUpIcon v-if="stock.change >= 0" class="h-4 -ml-1 text-copper-700" data-testid="stock-change-positive" />
    <ArrowLongDownIcon v-else class="h-4 -ml-1 text-red-700" data-testid="stock-change-negative" />{{ formatTradeValue(stock.change) }} ({{
      stock.percent_change.toFixed(1)
    }}%)
  </p>
</template>

<script lang="ts" setup>
import { ArrowLongUpIcon, ArrowLongDownIcon } from '@heroicons/vue/20/solid'
import { formatTradeValue } from '@/lib/utils'

defineProps({
  stock: {
    type: Object,
    required: true,
  },
})
</script>
